var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5327: {
		fallback: () => (() => (__webpack_require__(9321))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	6045: {
		fallback: () => (() => (__webpack_require__(3274))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	5244: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6467: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	4137: {
		fallback: () => (() => (__webpack_require__(4518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	6129: {
		fallback: () => (() => (__webpack_require__(5936))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	4082: {
		fallback: () => (__webpack_require__.e(5695).then(() => (() => (__webpack_require__(5695))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	924: {
		fallback: () => (__webpack_require__.e(8365).then(() => (() => (__webpack_require__(8365))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	9092: {
		fallback: () => (__webpack_require__.e(4645).then(() => (() => (__webpack_require__(4645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	3676: {
		fallback: () => (__webpack_require__.e(5195).then(() => (() => (__webpack_require__(5195))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	5065: {
		fallback: () => (__webpack_require__.e(3566).then(() => (() => (__webpack_require__(3566))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	5233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	4014: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(2181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	4685: {
		fallback: () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(8496))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	5657: {
		fallback: () => (__webpack_require__.e(1174).then(() => (() => (__webpack_require__(1174))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "i18next",

	},
	2949: {
		fallback: () => (__webpack_require__.e(5246).then(() => (() => (__webpack_require__(5246))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	1906: {
		fallback: () => (__webpack_require__.e(66).then(() => (() => (__webpack_require__(66))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-hook-form",

	},
	3691: {
		fallback: () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(1178))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-lazily",

	},
	8275: {
		fallback: () => (() => (__webpack_require__(1888))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	5315: {
		fallback: () => (__webpack_require__.e(1746).then(() => (() => (__webpack_require__(1746))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "dompurify",

	},
	8402: {
		fallback: () => (__webpack_require__.e(8483).then(() => (() => (__webpack_require__(8483))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-tooltip",

	},
	6236: {
		fallback: () => (__webpack_require__.e(8807).then(() => (() => (__webpack_require__(8807))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	},
	1623: {
		fallback: () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(537))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "axios",

	},
	5957: {
		fallback: () => (() => (__webpack_require__(8170))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-toast-store",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5327,6045,5244,6467,4137,6129,4082,924,9092,3676,5065,5233,5244,6467,4014,4137,5233,4685,5657,2949,6045,924,1906,3691,8275,6129,5315,4082,8402,6236,1623,5957];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		4685,
		5657,
		2949,
		6045,
		924,
		1906,
		3691,
		8275,
		6129,
		5315,
		4082,
		8402,
		6236
	],
	"5327": [
		5327
	],
	"5527": [
		6045,
		5244,
		6467,
		4137,
		6129,
		4082,
		924,
		9092,
		3676,
		5065,
		5233
	],
	"6083": [
		1623,
		5957
	],
	"8792": [
		5244,
		6467,
		4014,
		4137,
		5233
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}